
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import Preloader from './components/layout/Preloader';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Preloader />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
